import { render } from "./EnrolledCompanies.vue?vue&type=template&id=1a56288c"
import script from "./EnrolledCompanies.vue?vue&type=script&lang=ts"
export * from "./EnrolledCompanies.vue?vue&type=script&lang=ts"
script.render = render

export default script